export const richTextHasContent = (text: string): boolean => !!text && text !== '<p></p>'
